import _ from "lodash";
import React, { useState } from "react";
import { connect } from "react-redux";

import { Modal, Button, ToggleSwitch } from "@toddle-edu/ds-web";

import { useI18n } from "Hooks";
import { compose, graphql } from "lib/apolloClient";
import { GRAPHQL_ONGOING_QUERY_NETWORK_STATUS } from "Constants";
import { FormTextInput } from "UIComponents/InputTextField";
import FullScreenLoader from "UIComponents/FullScreenLoader";

import {
  ORGANIZATION,
  BLUEPRINT_SYNC,
} from "AddOnManager/routes/OrgAddOn/modules/OrgAddOnContants.js";
import { updateAddOnStatus } from "AddOnManager/routes/OrgAddOn/modules/OrgAddOnHelpers";
import { getInternalToolGenericDataQuery } from "InternalTools/modules/InternalToolsQuery";
import { getInternalToolGenericDataVariables } from "AddOnManager/modules/AddOnManagerUtils";

import classes from "./BluePrintSync.scss";
import withLoader from "UIComponents/GqlWithLoader/GqlWithLoader";

const BluePrintSyncWrapper = props => {
  const {
    orgId,
    updateAddOnStatus,
    internalToolGenericDataVariables,
    addOnSubTypeMap,
    onSuccessAddOnConfigChange = null,
  } = props;
  const { t } = useI18n(["course", "common"]);
  const [addOnCheckMap, setAddOnCheckMap] = useState({
    BASE_SYNC: _.get(addOnSubTypeMap, "BASE_SYNC.value", false),
    NEW_SYNC: _.get(addOnSubTypeMap, "NEW_SYNC.value", false),
  });

  const [fullScreenLoader, setFullScreenLoader] = useState(false);

  const handleOrgLevelToggle = async ({ addOnSubType = "BASE_SYNC" } = {}) => {
    setFullScreenLoader(true);
    setAddOnCheckMap(prev => ({
      ...prev,
      [addOnSubType]: !prev[addOnSubType],
    }));
    await updateAddOnStatus({
      orgId,
      addOnType: BLUEPRINT_SYNC,
      updateOn: ORGANIZATION,
      newStatus: !addOnCheckMap[addOnSubType],
      queryVariables: internalToolGenericDataVariables,
      addOnSubType,
    });
    if (!_.isNil(onSuccessAddOnConfigChange)) onSuccessAddOnConfigChange();
    setFullScreenLoader(false);
  };

  return (
    <div className={classes.container}>
      <FormTextInput
        size="large"
        label={t("common:org_id")}
        error=""
        value={orgId}
        isRequired={true}
        disabled={true}
      />
      {/* <div className={classes.switchContainer}>
        <div>{t("course:blueprint_sync_new_ui")}</div>
        <div className={classes.actionItems}>
          <ToggleSwitch
            checked={addOnCheckMap["NEW_SYNC"]}
            onChange={() => handleOrgLevelToggle({ addOnSubType: "NEW_SYNC" })}
          />
        </div>
      </div> */}
      <div className={classes.switchContainer}>
        <div>{t("common:blueprint_sync")}</div>
        <div className={classes.actionItems}>
          <ToggleSwitch
            checked={addOnCheckMap["BASE_SYNC"]}
            onChange={() => handleOrgLevelToggle({ addOnSubType: "BASE_SYNC" })}
          />
        </div>
      </div>
      {fullScreenLoader ? <FullScreenLoader /> : null}
    </div>
  );
};

const mapStateToProps = (state, ownProps) => {
  const { orgId } = ownProps;

  const internalToolGenericDataVariables = getInternalToolGenericDataVariables({
    orgId,
    addOnType: BLUEPRINT_SYNC,
  });

  return {
    isData: true,
    isLoading: false,
    internalToolGenericDataVariables,
    orgId,
  };
};

const mapActionCreators = { updateAddOnStatus };

const BluePrintSyncWithLoader = compose(
  connect(mapStateToProps, mapActionCreators),
  graphql(getInternalToolGenericDataQuery, {
    name: "getInternalToolGenericData",
    skip: ({ orgId }) => _.isEmpty(orgId),
    options: ({ internalToolGenericDataVariables }) => ({
      variables: internalToolGenericDataVariables,
      fetchPolicy: "cache-and-network",
    }),
    props: ({
      getInternalToolGenericData,
      ownProps: { isData, isLoading },
    }) => {
      const data = _.get(getInternalToolGenericData, "platform");

      const queryData = _.get(data, "internalToolsGenericQuery.data", []);

      const addOnSubTypeMap = _.keyBy(queryData, "addOnSubType");

      return {
        addOnSubTypeMap,
        isData: !_.isEmpty(data) && isData,
        isLoading:
          _.includes(
            GRAPHQL_ONGOING_QUERY_NETWORK_STATUS,
            getInternalToolGenericData.networkStatus
          ) || isLoading,
      };
    },
  }),
  withLoader
)(BluePrintSyncWrapper);

const BluePrintSync = ({
  orgId,
  closeModal,
  onSuccessAddOnConfigChange = null,
}) => {
  const { t } = useI18n(["common"]);

  return (
    <Modal width="580px" height="700px" isOpen onClose={closeModal}>
      <Modal.Header title={t("common:blueprint_sync")} isClosable />
      <Modal.Body isScrollable>
        <BluePrintSyncWithLoader
          onSuccessAddOnConfigChange={onSuccessAddOnConfigChange}
          closeModal={closeModal}
          orgId={orgId}
        />
      </Modal.Body>

      <Modal.Footer>
        <div className={classes.footer}>
          <div className={classes.rightFooterContainer}>
            <Button variant="outlined-subtle" size="large" onClick={closeModal}>
              {t("common:close")}
            </Button>
          </div>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default BluePrintSync;
